// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PublicSchemaTypes from '../../graphql/public/PublicSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type UserDetailFragment = (
  { __typename?: 'UserModelSelf' }
  & Pick<PublicSchemaTypes.UserModelSelf, 'id' | 'profile_img_url' | 'uploaded_img_url' | 'image_url' | 'display_name' | 'email' | 'first_name' | 'last_name' | 'organisation_id' | 'position' | 'verified' | 'step' | 'states' | 'is_active' | 'is_archived' | 'timezone' | 'organisation_role' | 'employee_id' | 'area' | 'location' | 'department' | 'custom_1' | 'custom_2' | 'custom_3' | 'password_last_updated_at' | 'canViewAnalytics' | 'isMemberOfCPDGroup' | 'isAdminOfSomeGroup' | 'userIdentity' | 'locale'>
  & { preferences: (
    { __typename?: 'UserPreferences' }
    & Pick<PublicSchemaTypes.UserPreferences, 'sendCommentSummaryEmails' | 'highContrast'>
  ) }
);

export type SessionQueryVariables = PublicSchemaTypes.Exact<{
  sid?: PublicSchemaTypes.Maybe<PublicSchemaTypes.Scalars['String']>;
}>;


export type SessionQuery = (
  { __typename?: 'Query' }
  & { session?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserSessionModelSelf' }
    & Pick<PublicSchemaTypes.UserSessionModelSelf, 'id' | 'created_at' | 'expires' | 'session_attributes_data'>
    & { user: (
      { __typename?: 'UserModelSelf' }
      & UserDetailFragment
    ) }
  )> }
);

export const UserDetailFragmentDoc = gql`
    fragment userDetail on UserModelSelf {
  id
  profile_img_url
  uploaded_img_url
  image_url
  display_name
  email
  first_name
  last_name
  organisation_id
  position
  verified
  step
  states
  is_active
  is_archived
  timezone
  organisation_role
  employee_id
  area
  location
  department
  custom_1
  custom_2
  custom_3
  password_last_updated_at
  canViewAnalytics
  isMemberOfCPDGroup
  isAdminOfSomeGroup
  userIdentity
  locale
  preferences {
    sendCommentSummaryEmails
    highContrast
  }
}
    `;
export const SessionDocument = gql`
    query Session($sid: String) {
  session(sid: $sid) {
    id
    created_at
    expires
    session_attributes_data
    user {
      ...userDetail
    }
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useSessionQuery__
 *
 * To run a query within a React component, call `useSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionQuery({
 *   variables: {
 *      sid: // value for 'sid'
 *   },
 * });
 */
export function useSessionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SessionQuery, SessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
      }
export function useSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SessionQuery, SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
        }
export type SessionQueryHookResult = ReturnType<typeof useSessionQuery>;
export type SessionLazyQueryHookResult = ReturnType<typeof useSessionLazyQuery>;
export type SessionQueryResult = Apollo.QueryResult<SessionQuery, SessionQueryVariables>;